"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.black = void 0;
var _styledComponents = require("styled-components");
var _utilities = require("../../../utilities");
var SpecHighlight = _interopRequireWildcard(require("./index.styled"));
var V2 = _interopRequireWildcard(require("./V2/index.styled"));
const generateSpecHighlightTheme = function () {
  let defaultTextColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#000";
  let svgFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function (_ref) {
    let {
      textColor
    } = _ref;
    return `
  ${SpecHighlight.Label} {
    color: ${(0, _utilities.colorToAlphaHex)(textColor, 0.7) || (0, _utilities.colorToAlphaHex)(defaultTextColor, 0.7)};
  }

  ${SpecHighlight.Value} {
    color: ${textColor || defaultTextColor};
  }

  ${SpecHighlight.Description} {
    color: ${(0, _utilities.colorToAlphaHex)(textColor, 0.7) || (0, _utilities.colorToAlphaHex)(defaultTextColor, 0.7)};
  }

  ${V2.Icon} {
    ${V2.iconSVGFilter(svgFilter)}
  }
`;
  };
};
const white_filter = "brightness(0) saturate(100%) invert(100%) sepia(1%) saturate(4192%) hue-rotate(31deg) brightness(116%) contrast(100%);";
const black = exports.black = (0, _styledComponents.css)`
  ${function (_ref2) {
  let {
    textColor
  } = _ref2;
  return generateSpecHighlightTheme("#FFF", white_filter)({
    textColor
  });
}};
`;
const black_filter = "brightness(0) saturate(100%) invert(0%) sepia(84%) saturate(7500%) hue-rotate(329deg) brightness(89%) contrast(114%);";
const white = exports.white = (0, _styledComponents.css)`
  ${function (_ref3) {
  let {
    textColor
  } = _ref3;
  return generateSpecHighlightTheme("#000", black_filter)({
    textColor
  });
}};
`;